import { Component } from '@angular/core'
import { FormGroup, FormControl, Validators } from '@angular/forms'
import { PublicPageTitleService } from '@public/app/services/public-page-title.service'
import { AuthService } from '@shared/services/auth.service'
import { Router } from '@angular/router'
import { GameDataService } from '@shared/services/game-data.service'
import { faUser } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss'],
})
export class RegisterPageComponent {
  registerForm: FormGroup
  pageTitle = 'Regisztráció'
  faUser = faUser

  constructor(
    private publicPageTitleService: PublicPageTitleService,
    private authService: AuthService,
    private gameDataService: GameDataService,
    private router: Router
  ) {
    this.registerForm = new FormGroup({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required),
      isPrivacyPolicyAccepted: new FormControl(false, Validators.requiredTrue),
      isTermsAndConditionsAccepted: new FormControl(false, Validators.requiredTrue),
    })
    this.publicPageTitleService.setPageTitle(this.pageTitle)
  }

  onRegister(): void {
    if (!this.registerForm.valid) {
      return
    }

    if (this.registerForm.value.password !== this.registerForm.value.confirmPassword) {
      console.log('Missing feature: handle password mismatch error')
      return
    }

    this.authService
      .createUserWithEmailAndPassword(
        this.registerForm.value.name,
        this.registerForm.value.email,
        this.registerForm.value.password
      )
      .then(cred => {
        if (cred.user) {
          this.gameDataService.savePlayerAgreements(
            cred.user.uid,
            this.registerForm.value.isPrivacyPolicyAccepted,
            this.registerForm.value.isTermsAndConditionsAccepted
          )
        }
        console.log('Missing feature: handle successful registration UI feedback')
        this.router.navigate(['/'])
      })
      .catch(error => {
        console.error('Registration error:', error)
      })
  }

  navigateToLogin(): void {
    this.router.navigate(['/login'])
  }
}
